import VerificationDialog from "../VerificationDialog/index";
import ItinererDialog from "../ItinererDialog";
import PlatformDialog from "../PlatformDialog";
import ReturnTripDialog from "../ReturnTripDialog";
import InfoDialog from "../InfoDialog";
import PriceListDialog from "../../Departures/Dialog/PriceListDialog";

export default function TripDialogs({
                                        printedInvoices,
                                        setPrintedInvoices,
                                        data,
                                        onSuccess,
                                        showVerificationDialog,
                                        showItinerer,
                                        showPlatformDialog,
                                        showReturnDialog,
                                        showInfoDialog,
                                        showPriceListDialog,
                                        setValue,
                                        setShowVerificationDialog,
                                        setShowItinerer,
                                        setShowPlatformDialog
                                    }) {

    return (
        <>
            {showVerificationDialog.open && (
                <VerificationDialog
                    onSuccess={onSuccess}
                    open={showVerificationDialog.open}
                    onClose={() => setShowVerificationDialog({open: false, data: null})}
                    tripData={showVerificationDialog.data}
                />
            )}

            {showItinerer.open && (
                <ItinererDialog
                    stationTimeAndPath={[]}
                    open={showItinerer.open}
                    onClose={() => setShowItinerer({open: false, data: null})}
                    data={showItinerer.data}
                    departureStationId={showItinerer.depStationId}
                    arrivalStationId={showItinerer.arrStationId}
                />
            )}
            {showPlatformDialog && (
                <PlatformDialog
                    setPrintedInvoices={setPrintedInvoices}
                    printedInvoices={printedInvoices}
                    additional={{
                        lineName: data?.printText || data?.lineName || null,
                        selectedLine: data?.lineId || null,
                        departureTripTime: data.departureTripTime || null,
                        startStation:  data?.depStationId || null,
                        endStation: data?.arrStationId || null,
                        operatorId: data?.operatorId || null,
                        carrier: data?.carrier || null,
                        discountId:  null,
                        discountAmount:  null,
                        platformNumber:  data?.platformNumber || null, // ovo se koristi samo zbog slip-a ne za internal
                    }}
                    onSuccess={onSuccess}
                    open={showPlatformDialog}
                    onClose={() => setShowPlatformDialog(false)}
                />
            )}

            {showInfoDialog?.open && (
                <InfoDialog
                    open={showInfoDialog.open}
                    data={showInfoDialog.data}
                    onClose={() =>
                        setValue("showInfoDialog", {
                            open: false,
                            data: null
                        })
                    }
                />
            )}

            {showPriceListDialog?.open && (
                <PriceListDialog
                    data={showPriceListDialog}
                    onClose={() =>
                        setValue("showPriceListDialog", {
                            open: false,
                            showRateCardSelect: false,
                            lineId: undefined,
                            linkId: undefined,
                            rateCardId: undefined,
                            tripId: undefined,
                            operatorName: undefined,
                            lineName: undefined,
                            editable: false,
                            arrStationId: undefined,
                            stationId: undefined,
                            journeyDate: undefined
                        })
                    }
                />
            )}

            {showReturnDialog && (
                <ReturnTripDialog
                    onClose={() => {
                        setValue("showReturnDialog", false);
                        setValue("returnTrip", null);
                    }}
                    onlyClose={() => setValue("showReturnDialog", false)}
                    open={showReturnDialog}
                />
            )}
        </>
    );
}
